import { render, staticRenderFns } from "./CommentContainer.vue?vue&type=template&id=064eb938&scoped=true&"
import script from "./CommentContainer.vue?vue&type=script&lang=js&"
export * from "./CommentContainer.vue?vue&type=script&lang=js&"
import style0 from "./CommentContainer.vue?vue&type=style&index=0&id=064eb938&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064eb938",
  null
  
)

export default component.exports